import { render, staticRenderFns } from "./TransitForm.vue?vue&type=template&id=7338aba6"
import script from "./TransitForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports